(function() { module.exports = window["axios"]; }());